import React from "react";

const ShimmerEffect = () => {
    return (
        <div
            className="animate-shimmer bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 bg-[length:400%_100%] h-full w-full rounded-[30px]">
        </div>
    );
};

export default ShimmerEffect;